import Content from '../components/Content';
import { Typography, Grid } from '@material-ui/core';

const Home = ({userStore}) => {
  return (
    <Content title="Relatórios" userStore={userStore}>
      <Typography variant="h1">Bem-vindo!</Typography>
    </Content>
  )
}
export default Home
